import React, { useState, useEffect, useRef } from 'react'
import { Icon, Image } from 'semantic-ui-react'

const ImageUploader = ({ url, uploadClicked }) => {
    const [image, setImage] = useState(url || null)
    const [file, setFile] = useState(null)
    const [error, setError] = useState(null)
    const fileInputRef = useRef(null)

    useEffect(() => {
        setImage(url || null)
        setError(null)
    }, [url])

    const handleImageClick = () => {
        fileInputRef.current.click()
    }

    const handleFileChange = event => {
        const selectedFile = event.target.files[0]
        if (selectedFile && selectedFile.type.startsWith('image/')) {
            const reader = new FileReader()
            reader.onloadend = () => {
                setImage(reader.result)
                setFile(selectedFile)
                setError(null)
            }
            reader.readAsDataURL(selectedFile)
        } else {
            setError('Please select a valid image file')
            alert('Please select a valid image file')
        }
    }

    const handleUpload = async () => {
        if (!file) {
            setError('No file selected')
            alert('No file selected')
            return
        }
        try {
            await uploadClicked(file)
        } catch (err) {
            console.error('Upload error:', err)
            setError('Failed to upload image')
            alert('Failed to upload image')
        }
    }

    const handleImageError = () => {
        setError('Failed to load image')
        setImage(null)
    }

    return (
        <div style={{ textAlign: 'center' }}>
            <div
                style={{
                    width: '300px',
                    height: '150px',
                    border: '2px dashed #444',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    backgroundColor: '#2a2b2c',
                    margin: '0 auto',
                    position: 'relative',
                }}
                onClick={handleImageClick}
            >
                {image ? (
                    <Image
                        src={image}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                        }}
                        onError={handleImageError}
                        inverted
                    />
                ) : (
                    <div>
                        <Icon name='image' size='big' color='grey' />
                        <p style={{ color: 'white' }}>Click to upload image</p>
                    </div>
                )}
                {error && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: '10px',
                            color: '#ff6666',
                            fontSize: '12px',
                        }}
                    >
                        {error}
                    </div>
                )}
            </div>
            <input
                type='file'
                accept='image/*'
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            {image && (
                <button
                    onClick={handleUpload}
                    style={{
                        marginTop: '10px',
                        backgroundColor: '#2185d0',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                    }}
                >
                    Upload Image
                </button>
            )}
        </div>
    )
}

export default ImageUploader